import * as SelectPrimitive from '@radix-ui/react-select'

import { useNearestShadowContainer } from '@/hooks/useNearestShadowContainer'

type SelectPortalProps = {
  children: React.ReactNode
}

export function SelectPortal(props: SelectPortalProps) {
  const { children } = props
  const { anchorRef, container } = useNearestShadowContainer()

  return (
    <>
      <span className="hidden" ref={anchorRef} />

      <SelectPrimitive.Portal
        container={container}
      >
        {children}
      </SelectPrimitive.Portal>
    </>
  )
}
